import GraduationHat from './resources/graduation_hat.png';
import Insights from './resources/insights.svg';
import NoJobFound from './resources/no_jobs_found.svg';
import MavenLogo from './resources/mavenwhite2.svg';
import Maven from './resources/maven.png';
import audioWave from './resources/audioWaveform.svg';
import emailTrendy from './resources/emailtrendy.svg';
import indianFLag from './resources/indian_flag.png';
import JobfeedQr from './resources/Jobfeed-Qr.svg';
import JobdetailQr from './resources/Jobdetail-Qr.svg';
import DesktopQr3 from './resources/Desktop-Qr-3.svg';
import DesktopQr4 from './resources/Desktop-Qr-4.svg';
import Premium from './resources/premium.png';
import ABImage from './resources/ambitionbox.png';
import HiristBanner from './resources/background-bg.webp';
import PlayStore from './resources/play-store.png';
import AppStore from './resources/app-store.png';
import RecLogin from './resources/recruiter-login@3x.png';
import JobseekerLogin from './resources/jobseeker-login@3x.png';
import Mobile from './resources/mobile@3x.png';
import HiristLogo2 from './resources/app-icon@3x.png';
import Facebook from './resources/fb.png';
import Instagram from './resources/insta.png';
import LinkedIn from './resources/linkedin.png';
import AppliedJobsQR from './resources/AppliedJobsQR.svg';
import SimilarJobsQR from './resources/SimilarJobsQR.svg';
import SavedJobsQR from './resources/SavedJobsQR.svg';
import HiristBackground from './resources/login_bkg.png';
import LockIcon from './resources/lock.png';
import UnlockIcon from './resources/un-lock.png';
import PhoneIcon from './resources/phone@3x.png';
import BgCurve from './resources/HiristCurve.png';
import NewUserIcon from './resources/user_profile_new.webp';
import HiristLogoOutlined from './resources/hirist-logo-outlined.png';
import Banner from './resources/banner.png';
import UserNotAuthorised from './resources/user_not_authorized.svg';
import Dots from './resources/dots.png';
import YellowInfoIcon from './resources/yellowInfoIcon.svg';
import UploadFile from './resources/upload.svg';
import HiristDelete from './resources/delete.svg';
import HiristPlus from './resources/plus.svg';
import HiristTick from './resources/tick.png';
import HiristTrophy from './resources/tropphy.png';
import ResumeTemplate1 from './resources/ResumeOverview2-1.png';

export {
  GraduationHat,
  audioWave,
  ABImage,
  Insights,
  NoJobFound,
  MavenLogo,
  emailTrendy,
  indianFLag,
  JobfeedQr,
  JobdetailQr,
  DesktopQr3,
  DesktopQr4,
  HiristBanner,
  PlayStore,
  AppStore,
  Mobile,
  RecLogin,
  JobseekerLogin,
  LinkedIn,
  Instagram,
  HiristLogo2,
  Facebook,
  HiristBackground,
  LockIcon,
  Premium,
  PhoneIcon,
  UnlockIcon,
  BgCurve,
  NewUserIcon,
  Maven,
  HiristLogoOutlined,
  Banner,
  UserNotAuthorised,
  YellowInfoIcon,
  UploadFile,
  HiristDelete,
  HiristPlus,
  HiristTick,
  HiristTrophy,
  ResumeTemplate1,
  AppliedJobsQR,
  SimilarJobsQR,
  SavedJobsQR,
  Dots,
};
